<template>
  <BaseModal name="calendar-replicate" title="Replicate Availability" @close="$emit('close')">
    <div class="calendarReplicateModal">
      <div test-id="description">
        Please choose the number of weeks you want to replicate your availability schedule from the current week shown
        on your screen.
      </div>
      <voxy-select
        v-model="weeksAmount"
        :options="availableWeeksToReplicate"
        theme="ghost"
        placeholder="Number of weeks"
      />
      <div v-if="hasError" test-id="error">Something went wrong, please try again.</div>
      <VoxySpinner v-if="isConfirming" :size="32" :stroke="2" />
      <VoxyButton v-else :disabled="!weeksAmount" view="primary" size="s" @click="handleConfirm"> Confirm </VoxyButton>
    </div>
  </BaseModal>
</template>

<script>
import { VoxySelect, VoxySpinner, VoxyButton } from '@voxy-team/vue-voxy';
import BaseModal from '@/components/BaseModal';

export default {
  name: 'CalendarReplicateModal',

  components: {
    BaseModal,
    VoxySelect,
    VoxySpinner,
    VoxyButton,
  },

  props: {
    confirmAction: {
      default: () => {},
      type: Function,
    },
  },

  data() {
    return {
      weeksAmount: null,
      availableWeeksToReplicate: Array.from({ length: 8 }, (_, index) => index + 1),
      isConfirming: false,
      hasError: false,
    };
  },

  methods: {
    async handleConfirm() {
      try {
        this.isConfirming = true;
        this.hasError = false;

        await this.confirmAction(this.weeksAmount);

        this.isConfirming = false;
        this.$emit('close');
      } catch (error) {
        this.isConfirming = false;
        this.hasError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.calendarReplicateModal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.voxy-select {
  width: 100%;
}
</style>
